<template>
	<div class="content background1" style="display: flex">
		<div class="tableBox9" v-if="!qrCodeShow">
			<div class="tableMes">
				<div class="table">
					<el-tabs v-model="activeNameTree" type="card" @tab-click="handleClickTree">
						<el-tab-pane :label="$t('label_429')" name="first">
							<template>
								<tree :dataTree="treeData" @getDeviceMes="getDeviceMes"></tree>
							</template>
						</el-tab-pane>
						<el-tab-pane :label="this.$t('label_161')" name="second">
							<template>
								<tree :dataTree="treeData2" @getDeviceMes="getDeviceMes"></tree>
							</template>
						</el-tab-pane>
					</el-tabs>
				</div>
			</div>
		</div>
		<div class="right-showbtn" @click="showBtn">
			<div class="right-showbtn-qrcode-background">
				<i v-if="qrCodeShow" class="el-icon-arrow-right" style="margin-top: 32px; margin-left: -3px; color: #FFFFFF;"></i>
				<i v-if="!qrCodeShow" class="el-icon-arrow-left" style="margin-top: 32px; margin-left: -3px; color: #FFFFFF;"></i>
			</div>
		</div>
		<div class="tableBox10" :style="{'padding':width=='0px'?'60px 0px 0px 0px':'60px 0px 0px 350px '}">
			<div class="tableMes">
				<div class="table" style="padding: 0">
					<div class="treeMes">
						<p class="title">{{deviceDetailMes.name}}</p>
						<div class="chooseBox spaceBetween">
							<div class="selectBox">
								<div>
									<div class="selectChoose">
										<div class="selectText" style="width: 150px;">
											<p>{{$t('label_134')}}</p>
										</div>
										<div class="select" style="width:350px">
											<el-select v-model="riskID" style="width: 210px" filterable :placeholder="$t('input_65')" clearable>
												<el-option :label="$t('label_272')" value="0" key="0"></el-option>
												<el-option v-for="(item,index) in riskList" :label="item.val" :value="item.key" :key="item.key"></el-option>
											</el-select>
										</div>
									</div>
								</div>
							</div>
							<div class="buttonBox">
								<div>
									<div class="chooseButton sendButton" @click="search"><i class="el-icon-search"></i>{{$t('btn_2')}}</div>
								</div>
							</div>
						</div>
						<div class="spotMes2Box" style="height: calc(100% - 120px);">
							<div class="buttonBox">
								<div>
									<div class="chooseButton searchButton" @click="add" v-if="MenuRoleList.indexOf('61')>=0"><i class="el-icon-circle-plus-outline"></i>{{$t('btn_14')}}</div>
									<div class="chooseButton searchButton" @click="edit" v-if="MenuRoleList.indexOf('62')>=0"><i class="el-icon-edit-outline"></i>{{$t('btn_15')}}</div>
									<div class="chooseButton deleteButton" @click="del" v-if="MenuRoleList.indexOf('63')>=0"><i class="el-icon-delete"></i>{{$t('btn_16')}}</div>
								</div>
							</div>
							<div class="tableMin" style="height: calc(100% - 90px);">
								<el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableDataList" highlight-current-row @current-change="handleCurrentChangeTreeTime"
								 border style="width: 100%;margin: 10px 0" height="100%" :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
									<el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index" :index="getIndex" width="50">
									</el-table-column>
									<el-table-column prop="dictContentKey" :label="$t('label_134')" align="left" width="200">
										<template slot-scope="scope">
											{{checkRisk(scope.row.dictContentKey)}}
										</template>
									</el-table-column>
									<el-table-column prop="content" :label="$t('label_137')" align="left">
									</el-table-column>
								</el-table>
								<Page class="item" ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
								 @parentMethod="searchPage"></Page>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<el-dialog v-loading="saveLoading" :title="editName" :visible.sync="dialogAdd" append-to-body :close-on-click-modal='false' width="600px" top="20%"
		 :before-close="handleClose" custom-class="dialogBox">
			<div class="dialogMes">
				<p>{{$t('label_134')}}</p>
				<div class="mesInput">
					<el-select v-model="newRisk.dictContentKey" style="width: 410px" filterable :placeholder="$t('input_65')">
						<el-option v-for="item in riskList" :key="item.key" :label="item.val" :value="item.key"></el-option>
					</el-select>
				</div>
			</div>
			<div class="dialogMes">
				<p>{{$t('label_137')}}</p>
				<div class="mesInput">
					<el-input style="width: 410px"  type="textarea" :placeholder="$t('input_46')"  v-model="newRisk.content"></el-input>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<div class="chooseButton sendButton" @click="newRiskSave">{{$t('btn_13')}}</div>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import "@/assets/css/map/map.css"
	import "@/assets/css/common/spot.css"
	import Page from "@/components/common/page";
	import TimePage from "@/assets/js/timePage/timePage.js";
	import utils from '@/utils/utils'
	import calendar from "@/components/list/calendar/calendar";
	import tree from "@/components/list/tree/maintainTree";
	import file from "@/assets/js/file/file.js";
	import checkItem from "@/components/list/displayPage/checkItemParam";
	import maintenanceItem from "@/components/list/displayPage/maintenanceItemParam";
	import inspectionItem from "@/components/list/displayPage/inspectionItemParam";
	import electronDocument from "@/components/list/displayPage/electronDocumentParam";
	import partInfo from "@/components/list/displayPage/partInfoParam";
	import common from "@/assets/js/common/common.js";

	export default {
		name: 'spotResumePage',
		components: {
			Page,
			calendar,
			tree,
			checkItem,
			maintenanceItem,
			inspectionItem,
			electronDocument,
			partInfo
		},
		data() {
			return {
        saveLoading: false,
				pageNum: 1,
				pageSize: 10,
				pageCount: 0,
				MenuRoleList: [],
				newRisk: {
					content: '',
					dictContentKey: '',
				},
				deviceDetailMes: {},
				tableChooseInfo: {},
				dialogAdd: false,
				editName: this.$t('btn_14'),
				treeData: {
					dataDevice: [],
					searchShow: true,
					statusShow: false,
					statusListShow: true,
					cardShow: true,
					dataAll: true,
					funtoGetMes: '2'
				},
				treeData2: {
					dataDevice: [],
					searchShow: true,
					statusShow: false,
					statusListShow: true,
					cardShow: true,
					dataAll: true,
					funtoGetMes: '3'
				},
				tableDataList: [],
				parameterData: [],
				activeNameTree: 'first',
				riskID: '0',
				riskList: [],
				width: '340px',
				qrCodeShow: false,
			}
		},
		watch: {},
		methods: {
			checkRisk(type) {
				var data = this.riskList.filter(function(item) {
					return item.key == type.toString();
				});
				if (data != '') {
					return data[0].val
				}
			},
			getIndex(index) {
				return (this.pageNum - 1) * this.pageSize + index + 1
			},
			handleClose() {
				this.dialogAdd = false;
			},
			add() {
				this.newRisk = {
						content: '',
						dictContentKey: '',
					},
					this.dialogAdd = true;
				this.editName = this.$t('btn_14');
				this.newRisk.type = this.deviceDetailMes.type
				this.newRisk.deviceId = this.deviceDetailMes.id
			},
			edit() {
				this.editName = this.$t('btn_15');
				if (this.tableChooseInfo.id != '' && this.tableChooseInfo.id != null) {
					this.newRisk.id = this.tableChooseInfo.id;
					this.newRisk.content = this.tableChooseInfo.content;
					this.newRisk.dictContentKey = this.tableChooseInfo.dictContentKey.toString();
					this.dialogAdd = true;
				} else {
					utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
				}
			},
			newRiskSave() {
        this.saveLoading = true;
				if (this.newRisk.content == "") {
					utils.messageAlert(this.$t('msg_42'), this.$t('label_358'), this.$t('label_100'));
          this.saveLoading = false;
					return
				}
				if (this.editName == this.$t('btn_14')) {
					file.addRisk(this.newRisk).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.search();
							this.dialogAdd = false;
							this.newRisk = {
									content: '',
									dictContentKey: '',
								},
								this.$message({
									message: this.$t('msg_23'),
									type: 'success'
								});
						}
            this.saveLoading = false;
					}).catch((response) => {
						console.log(response)
            this.saveLoading = false;
					})
				} else {
					file.editRisk(this.newRisk).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.search();
							this.dialogAdd = false;
							this.newRisk = {
									content: '',
									dictContentKey: '',
								},
								this.$message({
									message: this.$t('msg_23'),
									type: 'success'
								});
						}
            this.saveLoading = false;
					}).catch((response) => {
						console.log(response)
            this.saveLoading = false;
					})
				}
			},
			del() {
				let that = this;
				if (this.tableChooseInfo.id != '' && this.tableChooseInfo.id != null) {
					let param = {
						id: this.tableChooseInfo.id
					};
					this.$confirm(this.$t('msg_66') + '?', this.$t('label_358'), {
						confirmButtonText: this.$t('label_100'),
						cancelButtonText: this.$t('btn_1'),
						type: 'warning'
					}).then(() => {
						file.delRisk(param).then((response) => {
							const data = response.data;
							if (data.code == "1") {
								that.search();
							} else {
								utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
							}
						}).catch((response) => {
							console.log(response)
						})
					}).catch(() => {

					});
				} else {
					utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
				}

			},

			handleCurrentChangeTree(info) {
				this.tableDataTreeInfo = info;
			},

			getDeviceMes(data) {
				if (data.name == this.$t('label_272')) {
					this.deviceDetailMes = {}
					this.deviceDetailMes.name = this.$t('label_272')
					this.deviceDetailMes.id = '0';
					if (this.activeNameTree == 'first') {
						this.deviceDetailMes.type = 0;
					} else {
						this.deviceDetailMes.type = 2;
					}
					this.search()
				} else {
					this.deviceDetailMes = data;
					this.search()
				}
			},

			searchDeviceMesDetail() {
				let param = {
					pageNum: 1,
					pageSize: this.pageSize,
				}
				this.$refs.checkItemDisplay.searchPage(param);
				this.$refs.maintenanceItemDisplay.searchPage(param);
				this.$refs.inspectionItemDisplay.searchPage(param);
				this.$refs.electronDocumentDisplay.searchPage(param);
				this.$refs.partInfoDisplay.searchPage(param);
			},
			tableDataTreeInfoEdit() {
				if (Object.keys(this.tableDataTreeInfo).length > 0) {
					this.dialogDeviceSpot = true;
					this.tableDataTreeEdit = this.tableDataTreeInfo
				} else {
					utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
				}
			},
			getRiskList() {
        file.getByDictIdALL({dictId: 7, languageType: sessionStorage.getItem("languageType")}).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.riskList = data.data
					}
				}).catch((response) => {
					console.log(response)
				})
        // file.getRiskList().then((response) => {
        //   const data = response.data;
        //   if (data.code == "1") {
        //     this.riskList = data.data
        //   }
        // }).catch((response) => {
        //   console.log(response)
        // })
			},
			handleCurrentChangeTreeTime(info) {
				this.tableChooseInfo = info;
			},
			handleClickTree(tab, event) {
				this.deviceDetailMes = {}
				this.deviceDetailMes.name = this.$t('label_272')
				this.deviceDetailMes.id = '0';
				if (tab.name == 'first') {
					this.deviceDetailMes.type = 0;
				} else {
					this.deviceDetailMes.type = 2;
				}
				this.search()
			},


			search() {
				let param = {
					pageNum: 1,
					pageSize: this.pageSize,
				}
				this.searchPage(param);
			},
			searchPage(param) {
				var dataParam = {
					deviceId: this.deviceDetailMes.id,
					type: this.deviceDetailMes.type,
					id: this.riskID,
				};
				var newParam = Object.assign(param, dataParam);
				file.getRiskContent(newParam).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.tableDataList = data.data.records;
						this.pageSize = data.data.size;
						this.pageCount = data.data.total;
						this.pageNum = data.data.current;
						this.$refs['pageModel'].setCurrent(this.pageNum);
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			showBtn() {
				this.qrCodeShow = !this.qrCodeShow;
				if (this.qrCodeShow) {
					this.width = "0px";
				} else {
					this.width = "340px";
				}
			},
		},
		created() {
			this.getRiskList();
			this.MenuRoleList = this.$store.getters.getMenu;
		}
	}
</script>

<style>
	.right-showbtn-qrcode-background {
		/* position: absolute; */
		width: 10px;
		height: 80px;
		background-color: #9c9c9c;
		border-top-right-radius: 10px;
		border-bottom-right-radius: 10px;
		margin: auto;
	}
	.right-showbtn {
		width: 10px;
		height: 100%;
		display: flex;
		position: relative;
		z-index: 100000;
	}
</style>



// WEBPACK FOOTER //
// src/pages/basic/riskPage.vue